export enum AnniversaryTypes {
	birthday = 0,
	anniversary = 1,
}
